import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-lite-button',
  templateUrl: './lite-button.component.html',
  styleUrls: ['./lite-button.component.scss'],
  imports: [CommonModule],
  providers: [],
})
export class LiteButtonComponent {
  icon = input<string>(''); // this icon works only with prime ng -> example: pencil
  text = input<string>('');
  block = input<boolean>(false);
  buttonClick = output<void>();
}
